import config from './imageSizes';
import crypto from 'crypto';

interface GetImageUrlProps {
	url: string;
	focalPoint?: {
		left: number;
		top: number;
	};
	width?: number;
	height?: number;
	format?: 'webp';
}

function addUmbracoHmac(url: string, secretKey: string): string {
	const secret = new Uint8Array(Buffer.from(secretKey, 'hex'));
	const parsedUrl = new URL(url, 'https://placeholder.local');
	const relativeUrl = parsedUrl.pathname + parsedUrl.search;
	const hmac = crypto.createHmac('sha256', secret).update(relativeUrl).digest('hex').toLowerCase();

	// Append hmac at the very end
	const separator = url.includes('?') ? '&' : '?';
	return `${url}${separator}hmac=${hmac}`;
}

export const GetImageUrl = ({ url, width, format }: GetImageUrlProps): string => {
	if (!url) return '';

	let imageUrl = `${url}?width=${width}&quality=${config.images.quality}`;

	if (format) imageUrl = `${imageUrl}&format=webp`;

	const base64EncodedSecretKey = Buffer.from(process.env.NEXT_PUBLIC_HMAC_SECRET_KEY || '', 'base64').toString('hex');

	imageUrl = addUmbracoHmac(imageUrl, base64EncodedSecretKey || '');

	return imageUrl;
};

export const GetSrcSetString = ({
	url,
	focalPoint,
	format,
	aspectRatio,
}: {
	url: string;
	focalPoint: { top: number; left: number };
	format?: 'webp';
	aspectRatio?: number;
}): string => {
	const { imageSizes } = config.images;

	let string = '';

	imageSizes.map((width) => {
		let height = 0;

		if (aspectRatio) {
			height = aspectRatio * width;
		}

		return (string += `${GetImageUrl({
			url,
			focalPoint,
			height,
			width: width,
			format,
		})} ${width}w, `);
	});

	return string.substring(0, string.length - 2);
};
